var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentBri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 690.65 691.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#004796;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo Bank Rakyat Indonesia (BRI) icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.19,0H105.45C47.2,0,0,48.32,0,108.07V583.13c0,59.12,46.33,107.2,103.87,108L585,691.2c58.24,0,105.45-48.39,105.45-108.07l.24-475.06C690.65,48.32,643.45,0,585.19,0M162.44,635.81l-26.15.24c-31.63,0-57.3-26-57.3-58.17l-.23-4.52V134.54l.23-23.6c1.19-31.08,24.8-56.1,55.71-56.1h53.16c48.24,0,87.34,42,87.34,91.39a90.38,90.38,0,0,1-25.11,62.85L114.36,346.79,241.58,476.4c16.45,16.93,26.31,39.11,26.31,63.41,0,53-47.2,96-105.45,96m391.21-.39-237.21-.16s27.41-59.28,27.41-96c0-44.74-14.93-84.71-38.38-111.09l-81.14-82.72,82.81-85.59c24.64-23.21,41.09-64.29,41.09-111.17,0-37.11-10.33-69.94-26.78-93.85H378.9c48.23,0,87.34,42,87.34,91.39a90.7,90.7,0,0,1-25.12,62.85L307.93,345.37l276.63,282c-8.74,5.57-19.86,8-30.91,8m57.93-88.14-198.19-202,94.4-95.91c19.24-24.08,31.39-60.24,31.39-100.68,0-37.36-10.4-71-27.09-94.89l42.28,1.27c31.7,0,57.36,26.07,57.36,58.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentBri);
export default __webpack_public_path__ + "static/media/payment_bri.1dfc5c8cd0ceca2df1424962fbd54a83.svg";
export { ForwardRef as ReactComponent };